import Service from '../models/service.model';

/**
 * Read a service retrieved from the backend.
 * @param {Object} o
 * @returns {Service}
 */
function readService(o) {
  return new Service(
    o.id,
    o.name,
    o.order_number,
    o.duration,
    o.featured,
    o.acute,
    o.default,
    o.description,
    o.estimated_duration,
    o.patient_instructions,
    o.service_attentions,
    o.price,
    o.kela_price,
    o.combined_price,
    o.price_info,
    o.is_starting_price,
    o.categories,
    o.groups,
    o.internet_reservable,
    o.url,
  );
}

export {
  readService
};



// WEBPACK FOOTER //
// ./src/app/common/serializers/service.serializer.js